const menuItems = [
  {
    id: 1,
    name: 'Agenda',
    route: '/dashboard',
  },
  {
    id: 2,
    name: 'Dashboard',
    route: '/dash',
  },
  {
    id: 3,
    name: 'Pacientes Atendidos',
    route: '/pacientes',
  },
  {
    id: 4,
    name: 'Financeiro',
    route: '/financeiro',
  },
  {
    id: 5,
    name: 'Atendimentos Avaliados',
    route: '/avaliados',
  },
  {
    id: 6,
    name: 'FAQ',
    route: '/faq',
  },
]

export default menuItems
